export class ClaimRemoveCommand{
    identity: string;
    claim:string;

    constructor(identity:string,claim:string){
        this.identity = identity;
        this.claim = claim;
    }
}